import './HelpButton.css';

const HelpButton = ({handleHelpSelected}) => {
    return ( 
        <button className="btn-ob" onClick={handleHelpSelected}>Help</button>
    );
}
 
export default HelpButton;